export { DotsVertical as default } from './DotsVertical';
